import type { ModeConfig } from "../state/types";

/** Идентификатор режима смены */
export type ModeId = "quick" | "standard" | "long" | "endless";

/**
 * Таблица режимов: длительность, темп спавна, погода, события, уборка.
 */
export const MODES: Record<ModeId, ModeConfig> = {
  quick: {
    id: "quick",
    label: "Быстрая смена",
    sub: "3 минуты · высокий темп",
    time: 180,
    endless: false,
    spawn: 1.25,
    snow: 1.2,
    front: 1.35,
    events: 1.35,
    recover: 1.25,
    plow: 1.2,
    scoreGate: 1.0,
  },
  standard: {
    id: "standard",
    label: "Стандартная смена",
    sub: "5 минут · планирование",
    time: 300,
    endless: false,
    spawn: 1.0,
    snow: 1.0,
    front: 1.0,
    events: 1.0,
    recover: 1.0,
    plow: 1.0,
    scoreGate: 1.1,
  },
  long: {
    id: "long",
    label: "Долгая смена",
    sub: "8 минут · стратегия",
    time: 480,
    endless: false,
    spawn: 0.82,
    snow: 0.9,
    front: 0.85,
    events: 0.85,
    recover: 0.8,
    plow: 0.9,
    scoreGate: 1.2,
  },
  endless: {
    id: "endless",
    label: "Бесконечная смена",
    sub: "Волны фронта без лимита",
    time: 0,
    endless: true,
    spawn: 0.95,
    snow: 1.05,
    front: 1.0,
    events: 1.1,
    recover: 0.85,
    plow: 1.0,
    scoreGate: 1.0,
  },
};

/**
 * Конфиг режима по id (fallback — `quick`).
 * @param modeId — выбранный режим
 */
export function modeCfg(modeId: ModeId = "quick"): ModeConfig {
  return MODES[modeId] ?? MODES.quick;
}
